<template>
  <div class="policy">
    <menuBox :step="3"></menuBox>
    <div class="motto-box">
      <p class="bt">ให้บริการ</p>
    </div>
    <div class="strategy-box">
      <div class="bt">บริการที่เป็นเลิศ</div>
      <div class="title">กู้เงินง่าย ๆ ให้บริการทางการเงินอย่างมืออาชีพแก่คุณ </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/better1.png" alt="">
          <p>1.สมัครอย่างรวดเร็ว</p>
          <span>ผู้ใช้สามารถกรอกใบสมัครขอสินเชื่อออนไลน์ที่ง่ายและไม่ต้องใช้ขั้นตอนที่ซับซ้อน</span>
        </div>
        <div class="item">
          <img src="../assets/better2.png" alt="">
          <p>2. โควต้าที่ยืดหยุ่น</p>
          <span>มีตัวเลือกจำนวนเงินกู้ที่หลากหลายเพื่อตอบสนองความต้องการด้านเงินทุนที่แตกต่างกัน</span>
        </div>
        <div class="item">
          <img src="../assets/better3.png" alt="">
          <p>3. การตรวจสอบแบบเรียลไทม์</p>
          <span>ตรวจสอบเอกสารการสมัครอย่างรวดเร็วและแจ้งให้ผู้ใช้ทราบผลลัพธ์โดยเร็วที่สุด</span>
        </div>
      </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/better4.png" alt="">
          <p>4. ชำระคืนสะดวก</p>
          <span>รองรับวิธีการชำระคืนที่หลากหลายเพื่ออำนวยความสะดวกให้ผู้ใช้ปฏิบัติตามภาระผูกพันตามกำหนดเวลา</span>
        </div>
        <div class="item">
          <img src="../assets/better5.png" alt="">
          <p>5. ความปลอดภัยของข้อมูล</p>
          <span>เทคโนโลยีการเข้ารหัสขั้นสูงใช้เพื่อรับรองความเป็นส่วนตัวและความปลอดภัยของข้อมูลของผู้ใช้</span>
        </div>
        <div class="item">
          <img src="../assets/better6.png" alt="">
          <p>6. การสนับสนุนลูกค้า</p>
          <span>ให้บริการลูกค้าออนไลน์เพื่อตอบคำถามผู้ใช้ได้ตลอดเวลาและปรับปรุงประสบการณ์</span>
        </div>
      </div>
    </div>
    <div class="needHelp-box">
      <div class="left">
        <div class="title">
          ต้องการความช่วยเหลือ?
        </div>
        <div class="item">
          <img src="../assets/tel.png" alt="">
          <div>
            <p>+08 2663 5523</p>
            <span>Support Hotline</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/email.png" alt="">
          <div>
            <p>ads@wimutfamily.com</p>
            <span>Support Email</span>
          </div>
        </div>
        <div class="support" @click="step">สนับสนุน →</div>
      </div>
      <div class="right">
        <div class="list" v-for="(item, key) in list" :key="key">
          <div class="top">
            <p> {{ item.title }}</p>
            <img v-if="!item.show" src="../assets/add.png" alt="" @click="item.show = !item.show">
            <img v-else src="../assets/close.png" alt="" @click="item.show = !item.show">
          </div>
          <div class="text" v-if="item.show">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: '',
      list: [
        {
          title: "1. จะสมัครขอสินเชื่อได้อย่างไร?",
          text: "ผู้ใช้เพียงต้องดาวน์โหลดแอป กรอกข้อมูลส่วนบุคคล และส่งเอกสารที่จำเป็น จากนั้นระบบจะตรวจสอบใบสมัครของคุณอย่างรวดเร็ว",
          show: true
        },
        {
          title: "2.วงเงินกู้เท่าไหร่?",
          text: "จากการประเมินเครดิตของผู้ใช้ วงเงินสินเชื่ออยู่ระหว่าง 1,500 ถึง 90,000 บาท และจำนวนเฉพาะขึ้นอยู่กับผลการประเมิน",
          show: false
        },
        {
          title: "3. การอนุมัติสินเชื่อใช้เวลานานเท่าใด?",
          text: "ภายใต้สถานการณ์ปกติ จะทราบผลการตรวจสอบภายใน 1 ชั่วโมงหลังจากส่งใบสมัคร และจะปล่อยสินเชื่อทันทีในวันเดียวกัน",
          show: false
        },
        {
          title: "4. จะมั่นใจในความปลอดภัยของข้อมูลได้อย่างไร?",
          text: "แอปใช้เทคโนโลยีการเข้ารหัสขั้นสูง และข้อมูลผู้ใช้ทั้งหมดได้รับการคุ้มครองอย่างเข้มงวดและจะไม่รั่วไหลไปยังบุคคลที่สาม",
          show: false
        },
        {
          title: "5. ฉันสามารถชำระคืนเงินกู้ล่วงหน้าได้หรือไม่?",
          text: "รองรับการชำระคืนก่อนกำหนด และผู้ใช้สามารถชำระคืนเงินกู้ผ่านแอปได้ตลอดเวลาโดยไม่มีค่าธรรมเนียมเพิ่มเติม",
          show: false
        }
      ]
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "privacy" });
    },
  },
};
</script>
<style lang="less" scoped>
.policy {
  .motto-box {
    background-image: url(../assets/services.png);
    width: 100%;
    height: 500px;
    background-size: 100% 100%;
    padding: 180px 0 0 0;
    position: relative;
    box-sizing: border-box;

    .bt {
      text-align: center;
      margin-bottom: 35px;
      font-size: 58px;
      font-family: Roboto, Roboto;
      font-weight: 800;
      color: #FFFFFF;
    }
  }
}

.strategy-box {
  padding: 145px 310px 0;
  box-sizing: border-box;

  .bt {
    margin-bottom: 10px;
    text-align: center;
    font-size: 40px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #252B42;
    line-height: 57px;
  }

  .title {
    margin-bottom: 80px;
    text-align: center;
    font-size: 14px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #737373;
    line-height: 20px;
  }

  .lineBox {
    display: flex;

    .item {
      width: 33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: 0 38px 40px 0;
      padding: 22px 70px;
      box-sizing: border-box;
      box-shadow: 0px 8px 32px 0px rgba(48, 104, 156, 0.1);

      img {
        margin-bottom: 20px;
        width: 42px;
        height: 42px;
      }

      p {
        margin-bottom: 14px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #252B42;
        line-height: 40px
      }

      span {
        font-size: 18px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: rgba(37, 43, 66, 0.6);
        line-height: 24px;
      }
    }

    .item:nth-child(3n) {
      margin-right: 0;
    }
  }
}

.needHelp-box {
  padding: 160px 310px 120px;
  display: flex;
  justify-content: space-between;

  .left {
    .title {
      margin-bottom: 53px;
      font-size: 54px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #1A191E;
    }

    .item {
      display: flex;
      margin-bottom: 37px;
      overflow: hidden;

      img {
        margin-right: 26px;
        width: 53px;
        height: 53px;
      }

      p {
        margin-bottom: 10px;
        font-size: 20px;
        font-family: DM Sans, DM Sans;
        font-weight: 500;
        color: #1A191E;
      }

      span {
        font-size: 15px;
        font-family: Inter, Inter;
        font-weight: 500;
        color: rgba(26, 25, 30, 0.5);
      }
    }

    .support {
      cursor: pointer;
      margin-top: 20px;
      font-size: 20px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #00387A;
      overflow: hidden;
    }
  }

  .right {
    .list {
      width: 650px;
      padding: 35px 0;
      border-bottom: 1px solid #E8E8E8;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          cursor: pointer;
          width: 26px;
          height: 26px;
        }

        p {
          font-size: 22px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #1A191E;
        }
      }

      .text {
        margin-top: 18px;
        font-size: 17px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: rgba(26, 25, 30, 0.5);
        line-height: 27px;
      }
    }
  }
}
</style>
